import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-icon-key',
    imports: [],
    templateUrl: './icon-key.component.html',
    styleUrl: './icon-key.component.css'
})
export class IconKeyComponent {
    @Input() size: number = 14;
}